import { withExtras, withMeta } from 'shisell/extenders';

import { getDispatcher } from '@soluto-private/mx-analytics';

import { type AnalyticsDispatcher } from '@service-initiation/shared-clients-analytics-dispatcher';

const rootDispatcher = getDispatcher({
  dev: process.env.NX_PUBLIC_APP_ENV !== 'production',
  friendlyName: 'tech-care-mx-app',
  packageName: '@soluto-private/tech-care-mx-app',
  path: '/tech-care',
})
  .extend(withExtras({ ServiceChannel: 'Stores', ServiceType: 'TechCare' }))
  .extend(
    withMeta('sendToOpenSearch', process.env.NX_PUBLIC_APP_ENV === 'production')
  );

export const dispatcher: AnalyticsDispatcher = {
  dispatch: (eventName, extraData) =>
    rootDispatcher.dispatch(`Repairs_Scheduling_${eventName}`, extraData),
};
